import apiClient from '@/core/api/client';
import { API_ENDPOINTS } from '@/core/api/endpoints';

export interface DashboardResponse {
    success: boolean;
    data?: any;
    message?: string | null;
    error?: string | null;
}

/**
 * Dashboard API Service
 */
export const dashboardApi = {
    /**
     * Get global dashboard data (Super Admin)
     */
    getSuperAdminDashboard: async (startDate?: string, endDate?: string, signal?: AbortSignal): Promise<DashboardResponse> => {
        try {
            const params: any = {};
            if (startDate) params.start_date = startDate;
            if (endDate) params.end_date = endDate;
            const response = await apiClient.get<DashboardResponse>(API_ENDPOINTS.DASHBOARD.SUPER_ADMIN, { params, signal });
            return response.data;
        } catch (error: any) {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
                return { success: false, error: 'cancelled' };
            }
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch dashboard data'
            };
        }
    },

    /**
     * Get school dashboard data (School Admin / Employee)
     */
    getSchoolDashboard: async (schoolSlug: string, startDate?: string, endDate?: string, signal?: AbortSignal): Promise<DashboardResponse> => {
        try {
            const params: any = {};
            if (startDate) params.start_date = startDate;
            if (endDate) params.end_date = endDate;
            const response = await apiClient.get<DashboardResponse>(API_ENDPOINTS.DASHBOARD.SCHOOL(schoolSlug), { params, signal });
            return response.data;
        } catch (error: any) {
            if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
                return { success: false, error: 'cancelled' };
            }
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to fetch dashboard data'
            };
        }
    },
};
